import CardWrapper from "../../components/wrapper/card/CardWrapper";
import { IDeviceStateControllerReturn } from "../../../../../commonreact/main/services/devicestate/DeviceStateController";
import AppCSSService from "../../services/AppCSSService";

interface IProps {
  dsc: IDeviceStateControllerReturn
}

const HoneyPotRedirect = (props: IProps) => {

  return (
    <div className={AppCSSService.cardsWrapper}>

    <CardWrapper
      
      dsc={props.dsc}
      header={<>Thank you for your message!</>}
      //hideHeaderLine={true}
      //hideHeader={true}
    >

      <p>Thank you for messaging us. Our service team will contact you as soon as possible.</p>

      </CardWrapper>
      </div>
  );
};

export default HoneyPotRedirect;